import Enum from "app/api/enum";
import { handleGenericApiError } from "app/api/error";

import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_ENUM = "enum:ACTION_SAVE_ENUM";
export const ACTION_CLEAR_ENUM_CACHE = "enum:ACTION_CLEAR_ENUM_CACHE";

/**
 * Busca um enum específico e salva no store
 * @param {string} enumName - Nome do enum
 * @param {boolean} forceRefresh - Força busca no servidor
 * @returns {Function} Thunk action
 */
export const fetchEnum =
  (enumName, forceRefresh = false) =>
  async dispatch => {
    try {
      dispatch(addLoading());
      const data = await Enum.fetchEnum(enumName, forceRefresh);

      if (data) {
        dispatch({
          type: ACTION_SAVE_ENUM,
          payload: { enumName, data },
        });
      }

      return data;
    } catch (error) {
      handleGenericApiError(error);
      return null;
    } finally {
      dispatch(removeLoading());
    }
  };

/**
 * Busca múltiplos enums em paralelo
 * @param {Array<string>} enumNames - Array com nomes dos enums
 * @param {boolean} forceRefresh - Força busca no servidor
 * @returns {Function} Thunk action
 */
export const fetchMultipleEnums =
  (enumNames, forceRefresh = false) =>
  async dispatch => {
    try {
      dispatch(addLoading());
      const promises = enumNames.map(enumName =>
        Enum.fetchEnum(enumName, forceRefresh).then(data => ({
          enumName,
          data,
        }))
      );
      const results = await Promise.all(promises);

      // Salvar cada enum individualmente
      results.forEach(({ enumName, data }) => {
        if (data) {
          dispatch({
            type: ACTION_SAVE_ENUM,
            payload: { enumName, data },
          });
        }
      });

      return results.reduce((acc, { enumName, data }) => {
        acc[enumName] = data;
        return acc;
      }, {});
    } catch (error) {
      handleGenericApiError(error);
      return {};
    } finally {
      dispatch(removeLoading());
    }
  };

/**
 * Limpa o cache de enums
 * @returns {Function} Thunk action
 */
export const clearEnumCache = () => dispatch => {
  Enum.clearCache();
  dispatch({ type: ACTION_CLEAR_ENUM_CACHE });
};

/**
 * Remove um enum específico do cache
 * @param {string} enumName - Nome do enum a ser removido
 * @returns {Function} Thunk action
 */
export const removeEnumFromCache = enumName => dispatch => {
  Enum.removeFromCache(enumName);
  dispatch({
    type: ACTION_SAVE_ENUM,
    payload: { enumName, data: null },
  });
};
